export default {
  endpoints: {
    getURL: {
      route: "put",
      method: "GET",
    },
  },
};
